export enum DefaultEmailStyle {
  Formability = 1,
  Onestop = 2,
  Default = 3,

}

export const  DefaultEmailStyleName: { [key in DefaultEmailStyle]?: string } = {
  [DefaultEmailStyle.Formability]: 'Formability',
  [DefaultEmailStyle.Onestop]: 'Onestop',
  [DefaultEmailStyle.Default]: 'Default',
};
